module.exports = __webpack_public_path__ + "static/media/close-menu.5b5bd789.svg";